import { render } from "./WalletsSection.vue?vue&type=template&id=2c43754d"
const script = {}

import "./WalletsSection.vue?vue&type=style&index=0&id=2c43754d&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__